import * as React from 'react';
import Link from 'next/link';
import { NoticeIcon } from '@/components/Common/Table/Table.styled';
import TextOverFlow from '@/components/Common/TextOverFlow';
import { PostT } from '@/types/community';

function CommunityTableBody({ rows }: any) {
  const tableBodyRow = (
    { id, title, hit, created_at, type, user }: PostT,
    idx: number
  ) => {
    let thing = type === 'notice' ? '공지' : '오프';
    if (type === 'notice') {
      thing = '공지';
    } else if (type === 'free') {
      thing = '자유';
    } else {
      thing = '오프';
    }

    return (
      <tr key={idx}>
        <td>{thing}</td>
        <td>{type ? id : <NoticeIcon>공지</NoticeIcon>}</td>
        <td>
          <Link href={`/community/${type}/${id}`}>{title}</Link>
        </td>
        <td>
          <TextOverFlow width={100} title={user.name}>{user.name}</TextOverFlow>
        </td>
        <td>{hit}</td>
        <td>{new Date(created_at).toLocaleString()}</td>
      </tr>
    );
  };
  return rows.data.map((c: PostT, idx: number) => {
    return tableBodyRow(c, idx);
  });
}

export default CommunityTableBody;
